class Custommediaslider extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

        var swiper = new Swiper(".custom-content-slider-"+ this.getAttribute("data-sectionid"), {
            spaceBetween: 30,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        // $(this).css({"opacity":"1"});

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-media-with-text-slider", Custommediaslider);

class Slidervideo extends HTMLElement {
  constructor() {
    super();
    this.wordTimeout = null;
    this.fadeTimeout = null;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var sectionid = this.getAttribute("data-sectionid");
      var delay = parseInt(this.getAttribute("data-delay"), 10) || 7000;

      const section = document.querySelector('.slider-section--' + sectionid);
      if (!section) return;

      const words = section.querySelectorAll('.slideshow-text-container .featured-row__subtext p strong');

      if (words.length) {
        words.forEach(function (w) {
          w.classList.add('cycle-word');
          w.style.display = 'none';
        });

        let index = 0;
        const visibleMs = 1800;
        const fadeMs = 300;

        function loop() {
          const el = words[index];
          el.style.display = 'inline';
          el.classList.add('is-active');

          setTimeout(function () {
            el.classList.add('is-fading-out');

            setTimeout(function () {
              el.classList.remove('is-active', 'is-fading-out');
              el.style.display = 'none';
              index = (index + 1) % words.length;
              loop();
            }, fadeMs);
          }, visibleMs);
        }

        loop();
      }

      const container = section.querySelector('.swiper-container');
      if (!container || typeof Swiper === 'undefined') return;

      const swiper = new Swiper(container, {
        loop: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        autoplay: { delay: delay, disableOnInteraction: false },
        speed: 800,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: section.querySelector('.flex-next'),
          prevEl: section.querySelector('.flex-prev')
        },
        on: {
          slideChangeTransitionEnd: function () {
            resetAndPlayVideo(this.slides[this.activeIndex]);
          }
        }
      });

      const videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            resetAndPlayVideo(swiper.slides[swiper.activeIndex]);
          } else {
            pauseAllVideos();
          }
        });
      }, { threshold: 0.5 });

      videoObserver.observe(section);

      function pauseAllVideos() {
        section.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
      }

      function resetAndPlayVideo(activeSlide) {
        if (!activeSlide) return;
        pauseAllVideos();
        const video = activeSlide.querySelector('video');
        if (video) {
          video.currentTime = 0;
          video.play();
        }
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("slideshow-video", Slidervideo);

